import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { ApClassSignupStaff } from "./ApClassSignupStaff";
import type { InvalidSignupReasonStaff } from "./InvalidSignupReasonStaff";
import type { InvalidSignupReportDTOBase } from "./InvalidSignupReportDTOBase";
import type { JpClassSignupStaff } from "./JpClassSignupStaff";
import type { PersonStaff } from "./PersonStaff";
import type { TrackedModernBase } from "./TrackedModernBase";

export class InvalidSignupReportStaff implements InvalidSignupReportDTOBase, TrackedModernBase {
  constructor(public readonly reportId: number, public readonly personId: PersonStaff | null, public readonly apSignupId: ApClassSignupStaff | null, public readonly jpSignupId: JpClassSignupStaff | null, public readonly reasons: Array<InvalidSignupReasonStaff> | null, public readonly firstDetectedAt: Date, public readonly lastCheckedAt: Date, public readonly notes: string | null, public readonly createdOn: Date | null, public readonly createdBy: string | null, public readonly updatedOn: Date | null, public readonly updatedBy: string | null, public readonly reasonCount: number, public readonly reasonTypes: string | null, public readonly hasRequirementReason: boolean, public readonly personName: string | null, public readonly apSignupDate: Date | null, public readonly apClassId: number | null, public readonly apClassName: string | null, public readonly jpSignupDate: Date | null, public readonly jpClassId: number | null, public readonly jpClassName: string | null) {
    this.cbiServiceContext = null;
    this.personIdLoaded = this.personId != null;
    this.personIdCached = this.personId;
    this.apSignupIdLoaded = this.apSignupId != null;
    this.apSignupIdCached = this.apSignupId;
    this.jpSignupIdLoaded = this.jpSignupId != null;
    this.jpSignupIdCached = this.jpSignupId;
    this.reasonsLoaded = this.reasons != null;
    this.reasonsCached = this.reasons;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private personIdLoaded: boolean;
  private personIdCached: PersonStaff | null;
  private apSignupIdLoaded: boolean;
  private apSignupIdCached: ApClassSignupStaff | null;
  private jpSignupIdLoaded: boolean;
  private jpSignupIdCached: JpClassSignupStaff | null;
  private reasonsLoaded: boolean;
  private reasonsCached: Array<InvalidSignupReasonStaff> | null;
  async personIdLazy(): Promise<PersonStaff> {
    if (!this.personIdLoaded) {
      this.personIdCached = await this.cbiServiceContext!.reportService().getInvalidSignupReportStaffPersonId(this.reportId);
      this.personIdLoaded = true;
    }
    return this.personIdCached!;
  }
  async apSignupIdLazy(): Promise<ApClassSignupStaff | null> {
    if (!this.apSignupIdLoaded) {
      this.apSignupIdCached = await this.cbiServiceContext!.reportService().getInvalidSignupReportStaffApSignupId(this.reportId);
      this.apSignupIdLoaded = true;
    }
    return this.apSignupIdCached;
  }
  async jpSignupIdLazy(): Promise<JpClassSignupStaff | null> {
    if (!this.jpSignupIdLoaded) {
      this.jpSignupIdCached = await this.cbiServiceContext!.reportService().getInvalidSignupReportStaffJpSignupId(this.reportId);
      this.jpSignupIdLoaded = true;
    }
    return this.jpSignupIdCached;
  }
  async reasonsLazy(): Promise<Array<InvalidSignupReasonStaff>> {
    if (!this.reasonsLoaded) {
      this.reasonsCached = await this.cbiServiceContext!.reportService().getInvalidSignupReportStaffReasons(this.reportId);
      this.reasonsLoaded = true;
    }
    return this.reasonsCached!;
  }
}
